module.exports = __webpack_public_path__ + "img/discount-benefit.3c1c9211.svg";